import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-states',
    templateUrl: 'efast-filter-states.component.html',
    styleUrls: ['efast-filter-states.component.css'],
    standalone: false
})

export class EfastFilterStatesComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERStatesTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().STATES;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl1'),
            this.staticsService.getStateFilter().ALASKA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl2'),
            this.staticsService.getStateFilter().ALABAMA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl3'),
            this.staticsService.getStateFilter().ARKANSAS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl4'),
            this.staticsService.getStateFilter().US_TERRITORY_AMERICAN_SAMOA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl5'),
            this.staticsService.getStateFilter().ARIZONA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl6'),
            this.staticsService.getStateFilter().CALIFORNIA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl7'),
            this.staticsService.getStateFilter().COLORADO));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl8'),
            this.staticsService.getStateFilter().CONNECTICUT));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl9'),
            this.staticsService.getStateFilter().DISTRICT_OF_COLUMBIA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl10'),
            this.staticsService.getStateFilter().DELAWARE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl11'),
            this.staticsService.getStateFilter().FLORIDA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl12'),
            this.staticsService.getStateFilter().GEORGIA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl13'),
            this.staticsService.getStateFilter().US_TERRITORY_GUAM));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl14'),
            this.staticsService.getStateFilter().HAWAII));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl15'),
            this.staticsService.getStateFilter().IOWA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl16'),
            this.staticsService.getStateFilter().IDAHO));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl17'),
            this.staticsService.getStateFilter().ILLINOIS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl18'),
            this.staticsService.getStateFilter().INDIANA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl19'),
            this.staticsService.getStateFilter().KANSAS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl20'),
            this.staticsService.getStateFilter().KENTUCKY));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl21'),
            this.staticsService.getStateFilter().LOUISIANA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl22'),
            this.staticsService.getStateFilter().MASSACHUSETTS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl23'),
            this.staticsService.getStateFilter().MARYLAND));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl24'),
            this.staticsService.getStateFilter().MAINE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl25'),
            this.staticsService.getStateFilter().MICHIGAN));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl26'),
            this.staticsService.getStateFilter().MINNESOTA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl27'),
            this.staticsService.getStateFilter().MISSOURI));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl28'),
            this.staticsService.getStateFilter().MISSISSIPPI));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl29'),
            this.staticsService.getStateFilter().MONTANA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl30'),
            this.staticsService.getStateFilter().NEBRASKA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl31'),
            this.staticsService.getStateFilter().NEW_HAMPSHIRE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl32'),
            this.staticsService.getStateFilter().NEW_JERSEY));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl33'),
            this.staticsService.getStateFilter().NEW_MEXICO));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl34'),
            this.staticsService.getStateFilter().NEVADA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl35'),
            this.staticsService.getStateFilter().NEW_YORK));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl36'),
            this.staticsService.getStateFilter().NORTH_CAROLINA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl37'),
            this.staticsService.getStateFilter().NORTH_DAKOTA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl38'),
            this.staticsService.getStateFilter().US_TERRITORY_N_MARIANA_ISLANDS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl39'),
            this.staticsService.getStateFilter().OHIO));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl40'),
            this.staticsService.getStateFilter().OKLAHOMA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl41'),
            this.staticsService.getStateFilter().OREGON));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl42'),
            this.staticsService.getStateFilter().PENNSYLVANIA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl43'),
            this.staticsService.getStateFilter().US_TERRITORY_PUERTO_RICO));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl44'),
            this.staticsService.getStateFilter().RHODE_ISLAND));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl45'),
            this.staticsService.getStateFilter().SOUTH_CAROLINA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl46'),
            this.staticsService.getStateFilter().SOUTH_DAKOTA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl47'),
            this.staticsService.getStateFilter().TENNESSEE));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl48'),
            this.staticsService.getStateFilter().TEXAS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl49'),
            this.staticsService.getStateFilter().UTAH));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl50'),
            this.staticsService.getStateFilter().VIRGINIA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl51'),
            this.staticsService.getStateFilter().VERMONT));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl52'),
            this.staticsService.getStateFilter().US_TERRITORY_VIRGIN_ISLANDS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl53'),
            this.staticsService.getStateFilter().WASHINGTON));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl54'),
            this.staticsService.getStateFilter().WISCONSIN));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl55'),
            this.staticsService.getStateFilter().WEST_VIRGINIA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERStatesLbl56'),
            this.staticsService.getStateFilter().WYOMING));

        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.state.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue, true);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().STATES, this.queryValue, true)
    }

}